import React, { useEffect, useMemo, useRef, useState, type FC } from "react";

import {
	Flex,
	FlexItem,
	SELECT_VARIANT_WITH_CHECKBOX,
	Select,
	TEXT_VARIANT_BOLD,
	Text,
} from "mailup-web-components";
import { useIntl } from "react-intl";

import type { SubscriptionStatus } from "Types/beRecipientsApi";

import { filtersChangeCallback } from "Pages/RecipientsList/recoil/callbacks/filters";

import { fetchResultsCallback } from "Pages/RecipientsList/recoil/callbacks/callbacks";

import { searchFiltersState } from "Pages/RecipientsList/recoil/state/filters";

import { useRecoilCallback, useRecoilValue } from "recoil";

import { gainsightTrack } from "mailup-react-helpers";

const InputStatus: FC = () => {
	const intl = useIntl();

	const firstRender = useRef(true);
	const [expanded, setExpanded] = useState(false);

	const {
		status: { value },
	} = useRecoilValue(searchFiltersState);

	const filtersChange = useRecoilCallback(filtersChangeCallback, []);
	const fetchResults = useRecoilCallback(fetchResultsCallback, []);

	const handleStatusChange = (values: SubscriptionStatus[]): void => {
		gainsightTrack("mup_recipients_click_showRecipientsStatus", {});
		if (values.includes("EMAILUNSUBSCRIBED")) {
			gainsightTrack("mup_recipients_click_showEmailUnsubscribedSelected", {
				
			});
		}
		if (values.includes("EMAILSUBSCRIBED")) {
			gainsightTrack("mup_recipients_click_showEmailSubscribedSelected", {
				
			});
		}
		if (values.includes("EMAILPENDING")) {
			gainsightTrack("mup_recipients_click_showEmailPendingSelected", {
				
			});
		}
		if (values.includes("MOBILESUBSCRIBED")) {
			gainsightTrack("mup_recipients_click_showSmsSubscribedSelected", {
				
			});
		}
		if (values.includes("MOBILEUNSUBSCRIBED")) {
			gainsightTrack("mup_recipients_click_showSmsUnsubscribedSelected", {
				
			});
		}
		if (values.includes("MOBILEPENDING")) {
			gainsightTrack("mup_recipients_click_showSmsPendingSelected", {
				
			});
		}

		void filtersChange("status", values);
	};

	const handleExpandCollapse = (_expanded: boolean): void => {
		setExpanded(_expanded);
	};

	useEffect(() => {
		if (firstRender.current) {
			firstRender.current = false;
			return;
		}

		if (!expanded) {
			//  void searchResults()
			void fetchResults({ pageNumber: 1, subscriptionStatus: value });
		}
	}, [expanded, value, fetchResults]);

	const options: Array<{
		value: SubscriptionStatus;
		label: string;
	}> = useMemo(
		() => [
			{
				value: "EMAILSUBSCRIBED",
				label: intl.formatMessage({
					id: "Load.RecipientsList.StatusEmailSubscribed",
				}),
			},
			{
				value: "EMAILUNSUBSCRIBED",
				label: intl.formatMessage({
					id: "Load.RecipientsList.StatusEmailUnsubscribed",
				}),
			},
			{
				value: "EMAILPENDING",
				label: intl.formatMessage({
					id: "Load.RecipientsList.StatusEmailPending",
				}),
			},
			{
				value: "MOBILESUBSCRIBED",
				label: intl.formatMessage({
					id: "Load.RecipientsList.StatusMobileSubscribed",
				}),
			},
			{
				value: "MOBILEUNSUBSCRIBED",
				label: intl.formatMessage({
					id: "Load.RecipientsList.StatusMobileUnsubscribed",
				}),
			},
			{
				value: "MOBILEPENDING",
				label: intl.formatMessage({
					id: "Load.RecipientsList.StatusMobilePending",
				}),
			},
		],
		[intl],
	);

	return (
		<Flex alignItems="flex-start" gap="16px">
			<Flex height="36px" alignItems="center">
				<Text variant={TEXT_VARIANT_BOLD}>
					{intl.formatMessage({ id: "Load.RecipientsList.RecipientsStatus" })}
				</Text>
			</Flex>

			<FlexItem flexGrow={1}>
				<Select
					variant={SELECT_VARIANT_WITH_CHECKBOX}
					multiple
					searchable={false}
					options={options}
					value={value}
					onChange={handleStatusChange}
					data-mu-test="filters-status"
					onExpandCollapse={handleExpandCollapse}
					placeholder={intl.formatMessage({
						id: "Load.RecipientsList.SelectStatusPlaceholder",
					})}
				/>
			</FlexItem>
		</Flex>
	);
};

export default InputStatus;
